var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('router-view'),_c('base-loading',{attrs:{"isShow":_vm.$store.state.isShowLoading}}),_c('InquiryVerify')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }